import React, {Component} from 'react';

class ArrayDetails extends Component {
    static defaultProps = {
        data: "",
        label: "",
        empty: "",
        join: "、",
        maxWidth: 252,
    };

    constructor(props) {
        super(props);
    }
    render() {
        let data = this.props.data;
        let exp = this.props.exp;
        if(data && exp){
            data = data.map(function (item){
                let res = null;
                return eval(`res = ${exp}`);
            })
        }

        return <div style={{display:"inline-block"}}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{margin:"10px 0"}}><tbody><tr>
                <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                    {this.props.label}：
                </td>
                <td style={{width:this.props.maxWidth, color:"#252424"}} valign={"top"}>
                    {data?data.join(this.props.join):""}
                </td>
            </tr></tbody></table>
        </div>;
    }
}

export default ArrayDetails;
